import { referral } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const useReferralLevels = () => {
	return useQuery({
		queryKey: ['referrals-levels'],
		queryFn: () => referral.getReferralsLevels(),
		select: data => data.data
	})
}